import upAnimation from './upAnimation'
// 自定义指令
const directives = {
  upAnimation
}

export default {
  install(Vue) {
    Object.keys(directives).forEach((key) => {
      Vue.directive(key, directives[key])
    })
  }
}
